<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ایجاد کد تخفیف ریفرال جدید </template>
    <BRow>
      <BCol cols="12" md="6">
        <DiscountTypePicker
          v-model="masterDiscountCodePayload.discountType"
        ></DiscountTypePicker>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          inputId="masterName"
          inputLabel="کد مورد نظر"
          inputPlaceholder="john-doe"
          v-model="masterDiscountCodePayload.masterName"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <MasterPicker @getMaster="setMaster"></MasterPicker>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="masterDiscountCashBack"
          inputLabel="درصد بازگشت وجه به استاد (درصد)"
          inputPlaceholder="5"
          v-model="masterDiscountCodePayload.masterDiscountCashBack"
        >
          <template #append> % </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="studentDiscountValue"
          :inputLabel="handleInputLabel"
          :inputPlaceholder="handleInputPlaceholder"
          v-model="masterDiscountCodePayload.studentDiscountValue"
        >
          <template #append>
            {{ handleInputAppend }}
          </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="maxUseCount"
          inputLabel="تعداد قابل استفاده"
          inputPlaceholder="5"
          v-model="masterDiscountCodePayload.maxUseCount"
        >
          <template #append> بار </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomAppendText
          :isText="true"
          customRules="required|min:1"
          inputId="minFinalPriceLimit"
          inputLabel="حداقل مبلغ سفارش"
          inputPlaceholder="50000"
          v-model="masterDiscountCodePayload.minFinalPriceLimit"
        >
          <template #append> تومان </template>
        </CustomAppendText>
      </BCol>
      <BCol cols="12" md="6">
        <CustomDatePicker
          inputId="masterDiscountCodePayloadExpireDate"
          @getSelectedDate="setExpireDate"
          inputLabel="تاریخ اتمام تخفیف"
          inputPlaceholder="1403/06/05"
        >
        </CustomDatePicker>
      </BCol>
      <BCol cols="auto" class="ml-auto mt-1">
        <BButton variant="success" @click="sendCreateNewDiscountCodeRequest">
          ایجاد کد ریفرال
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      masterDiscountCodePayload: {
        masterName: null,
        userId: null,
        discountType: 1,
        masterDiscountCashBack: null,
        studentDiscountValue: null,
        maxUseCount: null,
        minFinalPriceLimit: null,
        expireDate: null,
      },
    };
  },
  methods: {
    async sendCreateNewDiscountCodeRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let createNewDiscountCode = new CreateNewDiscountCode(_this);
        createNewDiscountCode.setRequestParamDataObj(
          _this.masterDiscountCodePayload
        );
        await createNewDiscountCode.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کد تخفیف ریفرال با موفقیت ایجاد شد.",
              },
            });
            _this.masterDiscountCodePayload = {
              masterName: null,
              userId: null,
              discountType: 1,
              masterDiscountCashBack: null,
              studentDiscountValue: null,
              maxUseCount: null,
              minFinalPriceLimit: null,
              expireDate: null,
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setExpireDate(expireDate) {
      if (expireDate) {
        this.masterDiscountCodePayload.expireDate = new Date(
          expireDate
        ).toISOString();
      } else {
        this.masterDiscountCodePayload.expireDate = null;
      }
    },
    setMaster(master) {
      if (master) {
        this.masterDiscountCodePayload.userId = master.userId;
      } else {
        this.masterDiscountCodePayload.userId = null;
      }
    },
  },
  computed: {
    handleInputPlaceholder() {
      return this.masterDiscountCodePayload.discountType == 1 ? "10000" : "5";
    },
    handleInputAppend() {
      return this.masterDiscountCodePayload.discountType == 1 ? "تومان" : "%";
    },
    handleInputLabel() {
      return `تخفیف برای زبان آموز (${
        this.masterDiscountCodePayload.discountType == 1 ? "مبلغ" : "درصد"
      })`;
    },
  },
  components: {
    PageWrapper,
    MasterPicker,
    DiscountTypePicker,
    CustomAppendText,
    CustomDatePicker,
    TextInput,
    BRow,
    BCol,
    BButton,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import DiscountTypePicker from "@/views/components/Discount/DiscountTypePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import { BRow, BCol, BButton } from "bootstrap-vue";
import { CreateNewDiscountCode } from "@/libs/Api/MasterDiscountCodes";
</script>
